import React from "react";

const NonPharmacologicalToolTip = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[464px] ">
      <p className="text-teal-300 text-left text-body-sm  font-normal">
      Non- Pharmacological treatment should be combined with Pharmacological Treatment
      </p>
    </div>
  );
};

export default NonPharmacologicalToolTip;
